/**
 * create a container
 * and append to body
 * and return this
 **/
export function createContainer(tag, root) {
    if (tag === void 0) { tag = 'div'; }
    if (root === void 0) { root = document.body; }
    var container = document.createElement(tag);
    root.appendChild(container);
    return container;
}
//# sourceMappingURL=create-container.js.map